import { Suspense, useEffect, Fragment } from 'react';
import { Routes, Route, PathRouteProps, useLocation } from 'react-router-dom';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import {
  setIsLoadingAction,
  setMessageAction
} from 'store/modules/helper/actions';
import NavBar from 'components/organisms/Navbar';
import Authentication from 'pages/Authentication';
import AccessCode from 'pages/AcessCode';
import DidntReceiveCode from 'pages/DidntReceiveCode';
import Requirements from 'pages/Requirements';
import CreateCompany from 'pages/CreateCompany';
import Terms from 'pages/Terms';
import LinkedinRedirect from 'pages/LinkedinRedirect';
import InvitedUser from 'pages/InvitedUser';
import { ROUTES } from 'utils/constants';
import FormCompany from 'pages/FormCompany';
import Career from 'pages/Career';
import Slogan from 'pages/Slogan';
import Guard from './Guard';
import PublicGuard from './PublicGuard';

function Router() {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { pathname } = location;
  const { message, isLoading } = useAppSelector((state) => state.helper);

  useEffect(() => {
    if (message) {
      dispatch(setMessageAction(null));
    }
    if (isLoading) {
      dispatch(setIsLoadingAction(false));
    }
  }, [pathname]);

  interface RoutesProps extends PathRouteProps {
    path: string;
    hasAvatar?: boolean;
    backRoute?: string;
    element: JSX.Element;
    routes?: RoutesProps[];
    guard?: any;
  }

  const renderRoutes = (routes: RoutesProps[]): JSX.Element[] =>
    routes.map((route) => {
      const { path, element, routes: childrens, hasAvatar, backRoute } = route;
      const GuardRoute = route.guard || Fragment;

      return (
        <Route
          key={path}
          path={path}
          element={
            <GuardRoute>
              <>
                <NavBar backRoute={backRoute} hasAvatar={hasAvatar} />
                {element}
              </>
            </GuardRoute>
          }
        >
          {childrens && renderRoutes(childrens)}
        </Route>
      );
    });

  const routesList: RoutesProps[] = [
    {
      path: ROUTES.AUTHENTICATION,
      element: <Authentication />,
      guard: Guard
    },
    {
      path: ROUTES.ACCESS_CODE,
      element: <AccessCode />,
      guard: Guard,
      backRoute: ROUTES.AUTHENTICATION
    },
    {
      path: ROUTES.DIDINT_RECEIVE_CODE,
      element: <DidntReceiveCode />,
      guard: Guard,
      backRoute: ROUTES.AUTHENTICATION
    },
    {
      path: ROUTES.REQUIREMENTS,
      element: <Requirements />,
      guard: Guard,
      hasAvatar: true
    },
    {
      path: ROUTES.CREATE_COMPANY,
      element: <CreateCompany />,
      guard: Guard,
      hasAvatar: true
    },
    {
      path: ROUTES.FORM_COMPANY,
      element: <FormCompany />,
      hasAvatar: true
    },
    {
      path: ROUTES.CAREER,
      element: <Career />,
      hasAvatar: true
    },
    {
      path: ROUTES.SLOGAN,
      element: <Slogan />,
      hasAvatar: true
    },
    {
      path: ROUTES.TERMS,
      element: <Terms />,
      guard: Guard,
      hasAvatar: true
    },
    {
      path: ROUTES.LOGIN_LINKEDIN,
      element: <LinkedinRedirect />
    },
    {
      path: ROUTES.INVITED_USER,
      element: <InvitedUser />,
      guard: PublicGuard
    }
  ];

  return (
    <Suspense fallback={<span>loading...</span>}>
      <Routes>{renderRoutes(routesList)}</Routes>
    </Suspense>
  );
}

export default Router;
